<template>
  <div class="animated fadeIn row">
    <div class="card w-full">
      <div class="card-header">
        <strong>เพิ่มภาษา <i class="far fa-plus"></i></strong>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <div class="row">
                <div class="col-lg-2 text-center">
                  <p><b>ชื่อภาษา &nbsp;<i class="far fa-language"></i> :</b></p>
                </div>
                <div class="col-lg-10">
                  <v-select v-model="data.language" label="name" :options="languages" placeholder="กรุณากรอกชื่อภาษา">
                    <template slot="option" slot-scope="option">
                      <span v-bind:class="'flag-icon flag-icon-us'" v-if="option.short_name=='en'"></span><span v-bind:class="'flag-icon flag-icon-'+option.short_name" v-if="option.short_nameg!='en'"></span>
                      {{ option.name }}
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="offset-sm-3 offset-lg-3 col-sm-3 col-lg-3">
            <button class="btn btn-primary w-full" type="submit" @click="submitLanguage"><i class="far fa-clipboard-check"></i>
              ยืนยัน</button>
          </div>
          <div class="col-sm-3 col-lg-3">
            <router-link :to="{ name: 'LanguageList'}"><button class="btn btn-secondary w-full" type="button"><i class="far fa-times-square"></i>
                ยกเลิก</button></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import vSelect from 'vue-select'

  export default {
    components: {
      vSelect
    },
    data() {
      return {
        load: 0,
        language: {
          id: this.$route.params.id,
          data:{}
        },
        authorization: 'Bearer '+localStorage.getItem('z_token'),
        data: {
          language: null
        },
        languages: [
          { name: 'ไทย', short_name: 'th'},
          { name: 'English', short_name: 'en'},
          { name: 'Russia', short_name: 'ru'},
          { name: 'German', short_name: 'de'},
          { name: 'Chinese', short_name: 'cn'}
        ]
      }
    },
    methods: {
      submitLanguage(){
        if(this.language.id!=''&&this.language.id){
          this.updateLanguage()
        }else{
          this.createLanguage()
        }
      },
      createLanguage(){
        this.$http.post( process.env.VUE_APP_API_URL+'api/v1/language',{
          'name': this.data.language.name,
          'short_name': this.data.language.short_name
        },{
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          alert('ภาษา: '+response.body.json.language.name+' ('+response.body.json.language.short_name+') เพิ่มเรียบร้อย');
          this.$router.push({name:'LanguageList'})
        }).catch(function (error) {
          alert('ไม่สามารถเพิ่มภาษาได้ กรุณากรอกชื่อของภาษา!');
        })
      },
      updateLanguage(){
        this.$http.put( process.env.VUE_APP_API_URL+'api/v1/language/'+this.language.id,{
          'name': this.data.language.name,
          'short_name': this.data.language.short_name
        },{
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          alert('ภาษา: '+response.body.json.language.name+' ('+response.body.json.language.short_name+') แก้ไขเรียบร้อย');
          this.$router.push({name:'LanguageList'})
        }).catch(function (error) {
          alert('ไม่สามารถแก้ไขภาษาได้ กรุณากรอกชื่อของภาษา!');
        })
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      getLanguageByID(id) {
        this.startLoad(1)
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/language/'+id, {
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          this.data.language.name = response.body.json.name
          this.data.language.short_name = response.body.json.short_name
        }, response => {
          this.failLoad()
        })
      }
    },
    mounted() {
      if(this.language.id!=''&&this.language.id){
        this.getLanguageByID(this.language.id)
      }
    }
  }

</script>
